import { Fragment } from "react";
const SimpleButton = ({ title = '', iconPath = null, onClick, className = 'bg-primary', isLoading = false }) => {
    return (
        <div className={"nice-style-btn-ex flex flex-row " + className}
            onClick={() => {
                if (!isLoading) {
                    if (onClick) {
                        onClick()
                    }
                }
            }}>
            {iconPath && <img src={iconPath} alt={title} />}
            {title}

            <Fragment>
                {
                    isLoading && <span className='mx-2 loading-btn'>
                        <img src='/assets/icons/loading.svg' width='24' height='24' />
                    </span>
                }
            </Fragment>
        </div>
    )
};
export default SimpleButton;